const getLocationSkuHistoryQuery = `
/*
  We first get counts from stock count table
*/
with 
count_events as (
  select
  sl.sku,
  sl.partner_balance,
  sl.sl_balance,
  sl.sold,
  null::int as delivered, 
  sl.closing,
  s.submitted_at as date,
  s.updated_by as driver,
  case when not partial_count then 'stock_count' else 'stock_count_adjustment' end  as event_type,
  null as status,
  s.stock_count_id as event_id
  from avocado.data_stockcount s
  left join avocado.data_stockcountline sl on s.id = sl.stock_count_id 
  where s.fs_id = $1
  and sl.sku = $2
),
/*
  Then we get sent shipments
*/
shipments_sent as (
  select
    dsl.sku,
    null::int as partner_balance,
    null::int as sl_balance,
    null::int as sold,
    -dsl.amount as delivered,
    -dsl.amount as closing,
    dss.created_at as date,
    dss.created_by as driver,
    'shipment' as event_type,
    ds.status,
    ds.shipment_id as event_id
  from avocado.data_shipment ds 
  left join avocado.data_shipmentline dsl on dsl.shipment_id = ds.id 
  left join avocado.data_shipmentsnapshot dss on dss.shipment_id = ds.shipment_id and dss.status = 'sent'
  where ds.origin_id = $1
  and origin_sku = $2
  and ds.status IN ('sent', 'arrived', 'received')
  order by ds.created_at desc
),
/*
  Then we get received shipments
*/
shipments_received as (
  select
    dsl.sku,
    null::int as partner_balance,
    null::int as sl_balance,
    null::int as sold,
    dsl.amount as delivered,
    dsl.amount as closing,
    dss.created_at as date,
    dss.created_by as driver,
    'shipment' as event_type,
    ds.status,
    ds.shipment_id as event_id
  from avocado.data_shipment ds 
  left join avocado.data_shipmentline dsl on dsl.shipment_id = ds.id
  left join avocado.data_shipmentsnapshot dss on dss.shipment_id = ds.shipment_id and dss.status = 'received'
  where ds.destination_id = $1
  and destination_sku = $2
  and ds.status = 'received'
  order by ds.created_at desc
),
/*
  Then we union both to build a single shipments cte
*/
shipments as (
  select * from shipments_sent
  union all
  select * from shipments_received
),
/*
  Then we merge with shipments to create a timeline of stock activity. We also craft a partiton window using count dates
*/
stock_activity as (
  select 
    *,
    date as partition_window
  from count_events
  union all
  select 
    *,
  (select count_events.date from count_events where shipments.date > count_events.date order by count_events.date desc limit 1) as partition_window 
  from shipments
  where date is not null
),
/*
  We figure out current openings
*/
running_totals as (
  select 
    sum(closing) over (
      partition by partition_window
      order by date ) as running_total,
    *
  from stock_activity
  order by date desc
)
/*
  Tying it all together
*/
select 
  sku,
  date,
  event_type,
  event_id,
  driver,
  status,
  sold,
  delivered,
  sl_balance,
  partner_balance,
  running_total AS current_opening,
  LAG(running_totals.running_total, 1) OVER (ORDER BY running_totals.date) AS prev_opening
from running_totals
order by date;
`
module.exports = getLocationSkuHistoryQuery
